/**
 * Checks if `right` is before (or equal to) `left`
 * @param left date string, timestamp, or date object
 * @param right date string, timestamp, or date object
 */
export const isTimeStampBefore = (
    left: string | number | Date,
    right: string | number | Date,
) => {
    const l = new Date(left).getTime(),
        r = new Date(right).getTime()
    return l >= r ? true : false
}

/** Checks if `date1` and `date2` are the same day */
export function areEqualDate(date1: Date, date2: Date): boolean {
    if (!isDate(date1) || !isDate(date2)) {
        return false
    }
    return (
        date1.getDate() === date2.getDate() &&
        date1.getMonth() === date2.getMonth() &&
        date1.getFullYear() === date2.getFullYear()
    )
}

export function isDate(date: unknown): date is Date {
    return (
        date &&
        typeof (date as Date).getMonth === 'function' &&
        !Number.isNaN((date as Date).getMonth())
    )
}

/** Checks if timestamp is in seconds (Unix) */
export function isTimestampInSeconds(timestamp: number): boolean {
    return timestamp < 10000000000
}

export function isToday(date: Date): boolean {
    const today = new Date()
    return areEqualDate(today, date)
}

export function isYesterday(date: Date): boolean {
    const yesterday = new Date()
    yesterday.setDate(yesterday.getDate() - 1)
    return areEqualDate(yesterday, date)
}

export function isCurrentYear(date: Date): boolean {
    const now = new Date()
    return now.getFullYear() === date.getFullYear()
}

/** Returns a Javascript (milliseconds) timestamp from a Unix (seconds) or Javascript (milliseconds) timestamp */
export function msTimestamp(timestamp: number) {
    if (isTimestampInSeconds(timestamp)) {
        return timestamp * 1000
    }
    return timestamp
}

export function timestampToDate(timestamp: number | Date): Date | null {
    if (isDate(timestamp)) {
        return timestamp
    }
    if (timestamp && !Number.isNaN(timestamp)) {
        return new Date(msTimestamp(timestamp))
    } else {
        return null
    }
}

/**
 * UTC offset in hours (e.g. -8 for PST)
 */
export const utcOffset = -(new Date().getTimezoneOffset() / 60)
